import { useState } from 'react';
import { FileInput, FormField } from 'grommet';
import type { FileProps } from '@customTypes/types';

const MAX_FILE_SIZE_MB = 3;

export const File = (props: FileProps): JSX.Element => {
  const [errorMessage, setErrorMessage] = useState<string>("");

  return (
    <FormField
      name="file"
      htmlFor="file"
      label={`Maximum file size ${MAX_FILE_SIZE_MB}MB`}
      margin={{ top: 'small' }}
      error={errorMessage} // <-- this shows the error below the input
    >
      <FileInput
        id="file"
        name="file"
        messages={{
          dropPrompt: 'Drag and drop (optional)',
          browse: props.numFiles > 0 ? 'Replace file' : 'Select file',
        }}
        onChange={(_, files) => {
          const selectedFiles = files?.files as File[];
          if (!selectedFiles || selectedFiles.length === 0) return;

          const file = selectedFiles[0];
          const fileSizeInMB = file.size / (1024 * 1024);

          if (fileSizeInMB > MAX_FILE_SIZE_MB) {
            setErrorMessage(`File size exceeds ${MAX_FILE_SIZE_MB} MB limit.`);
            return;
          }

          setErrorMessage(""); // clear error if valid
          props.onFileChange(selectedFiles.length);
        }}
      />
    </FormField>
  );
};
